import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-add-instructions-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './add-instructions-icon.component.html',
  styleUrls: ['./add-instructions-icon.component.scss'],
})
export class AddInstructionsIconComponent {
  @Input() color!: string;
}
